import {
  LIST_PROJECT_INVOICE_DOC_REQUEST,
  LIST_PROJECT_INVOICE_DOC_SUCCESS,
  LIST_PROJECT_INVOICE_DOC_FAIL,
  DETAIL_PROJECT_INVOICE_DOC_REQUEST,
  DETAIL_PROJECT_INVOICE_DOC_SUCCESS,
  DETAIL_PROJECT_INVOICE_DOC_FAIL,
  CREATE_PROJECT_INVOICE_DOC_REQUEST,
  CREATE_PROJECT_INVOICE_DOC_SUCCESS,
  CREATE_PROJECT_INVOICE_DOC_FAIL,
  UPDATE_PROJECT_INVOICE_DOC_REQUEST,
  UPDATE_PROJECT_INVOICE_DOC_SUCCESS,
  UPDATE_PROJECT_INVOICE_DOC_FAIL,
  DELETE_PROJECT_INVOICE_DOC_REQUEST,
  DELETE_PROJECT_INVOICE_DOC_SUCCESS,
  DELETE_PROJECT_INVOICE_DOC_FAIL
} from '../../constants/project-invoice-doc'

const initialState = {
  loading: false,
  loadingCreate: false,
  loadingDetail: false,
  loadingDelete: false,
  invoiceDocSetups: [],
  invoiceDocSetup: null,
  error: null,
  pageable: {
    page: 1,
    size: 10,
    hits: 0
  }
}

const projectInvoiceDocReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_PROJECT_INVOICE_DOC_REQUEST:
      return { ...state, loading: true }
    case LIST_PROJECT_INVOICE_DOC_SUCCESS:
      return {
        ...state,
        loading: false,
        invoiceDocSetups: action.payload,
        pageable: action.pageable || state.pageable
      }
    case LIST_PROJECT_INVOICE_DOC_FAIL:
      return { ...state, loading: false, error: action.payload, invoiceDocSetups: [] }

    case DETAIL_PROJECT_INVOICE_DOC_REQUEST:
      return { ...state, loadingDetail: true, invoiceDocSetup: null }
    case DETAIL_PROJECT_INVOICE_DOC_SUCCESS:
      return { ...state, loadingDetail: false, invoiceDocSetup: action.payload }
    case DETAIL_PROJECT_INVOICE_DOC_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }

    case CREATE_PROJECT_INVOICE_DOC_REQUEST:
    case UPDATE_PROJECT_INVOICE_DOC_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_PROJECT_INVOICE_DOC_SUCCESS:
    case UPDATE_PROJECT_INVOICE_DOC_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_PROJECT_INVOICE_DOC_FAIL:
    case UPDATE_PROJECT_INVOICE_DOC_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }

    case DELETE_PROJECT_INVOICE_DOC_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_PROJECT_INVOICE_DOC_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_PROJECT_INVOICE_DOC_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }

    default:
      return state
  }
}

export default projectInvoiceDocReducer
